export const testAttributes = {
    ARTICLE_PAGE_CONTAINER: 'article-page-container',
    ARTICLE_POST_CONTAINER: 'article-post-container',
    ARTICLES_GRID_CONTAINER: 'articles-grid-container',
    ARTICLE_EDITORIAL_CONTAINER: 'article-editorial-container',
    ARTICLE_SOURCES_CONTAINER: 'article-sources-container',
};

export const containerId = 'article-sources-container-id';
export const tableOfContentHeadline = 'In This Article';
